module.exports = __webpack_public_path__ + "img/圆角矩形 2 拷贝 5@2x.d0b655c6.png";